import { AuthContextProps } from "../components/auth-context";
import { getData, postData, putData } from "./core";

export default class FileApi {
  static uri = "a/internet/file";
  context: AuthContextProps;
  constructor(context: AuthContextProps) {
    this.context = context;
  }
  get(id: number) {
    return getData({ uri: FileApi.uri, id, context: this.context });
  }

  getAll() {
    return getData({ uri: FileApi.uri, context: this.context });
  }

  post(
    type: number,
    phone: string,
    subCenterId: string,
    agentCode: string,
    ownershipType: string,
    installAddress: string,
    channelsCount: string
  ) {
    return postData({
      uri: FileApi.uri,
      data: {
        type,
        phone,
        subCenterId,
        agentCode,
        channelsCount,
        fullfillInfo: {
          ownershipType,
          installAddress,
        },
      },
      context: this.context,
    });
  }
}
